import appConfig from "../../config";
import { getLocalStorageInfo } from "../../utils";
import config from '../../config'

export const halcyonInstance = [484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const smbcInstance = [465].includes(getLocalStorageInfo()?.defaultLessor?.id);